import React, { useState, useContext, useEffect } from 'react'
import './Home.css'
import RestaurantSelector from '../../components/RestaurantSelector/RestaurantSelector'
import PopularFoods from '../../components/PopularFoods/PopularFoods'
import { StoreContext } from '../../Context/StoreContext'

const Home = ({ setShowProfileModal }) => {
  const { url, token, setSelectedRestaurant, selectedRestaurant, refreshFoodData } = useContext(StoreContext)

  // Clear selected restaurant when on home page to ensure general food items are loaded
  useEffect(() => {
    // Only clear selectedRestaurant if it's actually set (coming from a restaurant page)
    if (selectedRestaurant) {
      console.log('Home page: Clearing selected restaurant to load general food items')
      
      // Add a small delay to prevent race conditions and allow any in-flight requests to complete
      const timeoutId = setTimeout(() => {
        setSelectedRestaurant(null)
        // The StoreContext useEffect will handle refreshing the data when selectedRestaurant becomes null
      }, 100); // 100ms delay

      return () => clearTimeout(timeoutId);
    }
  }, [selectedRestaurant, setSelectedRestaurant])

  return (
    <>
      <RestaurantSelector />
      <PopularFoods />
    </>
  )
}

export default Home
